import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { FilterState } from '../features/filter/interfaces';

const useURLParams = (filters: FilterState) => {
  const [, setParams] = useSearchParams();

  useEffect(() => {
    setParams({
      motionType: `${filters.motionType}`,
      movingMass: `${filters.movingMass}`,
      impactVelocity: `${filters.impactVelocity}`,
      startVelocity: `${filters.startVelocity}`,
      cyclesPerHour: `${filters.cyclesPerHour}`,
      numShockAbsorbers: `${filters.numShockAbsorbers}`,
      fixedStop: `${filters.fixedStop}`,
      soft: `${filters.soft}`,
      robust: `${filters.robust}`,
      cushioningAdjustments: `${filters.cushioningAdjustments}`,
      cushioningTechnologies: `${filters.cushioningTechnologies}`,
      mountingType: `${filters.mountingType}`,
      forBatteryProduction: `${filters.forBatteryProduction}`,
      recommendedResults: `${filters.recommendedResults}`,
      momentOfInertia: `${filters.momentOfInertia}`,
      dropHeight: `${filters.dropHeight}`,
      startAngularVelocity: `${filters.startAngularVelocity}`,
      angularVelocity: `${filters.angularVelocity}`,
      lengthOfStick: `${filters.lengthOfStick}`,
      radiusToCylinder: `${filters.radiusToCylinder}`,
      distanceToShockAbsorber: `${filters.distanceToShockAbsorber}`,
      distanceToCenterOfMass: `${filters.distanceToCenterOfMass}`,
      externalDriveTorque: `${filters.externalDriveTorque}`,
      force: `${filters.force}`,
      coefficientOfFriction: `${filters.coefficientOfFriction}`,
      angleOfIncline: `${filters.angleOfIncline}`,
    });
  }, [filters, setParams]);
};

export default useURLParams;
